import { useState } from 'react';
import clamp from '../utils/clamp.js';
import { useListenToCombinrMessages } from './useListenToCombinrMessages.js';
import { usePollForRef } from './usePollForRef.js';

let viewport = {
    width: 0,
    height: 0,
    scrollTop: 0,
    headerHeight: 0,
};

let frame = {
    offsetTop: 0,
};

export function useFramePositioning(target, isActive = false) {
    const [_, setLastUpdated] = useState(Date.now());

    useListenToCombinrMessages(
        'scroll',
        (data) => {
            viewport = {...data.viewport};
            frame = {...data.frame};

            const applicationHeader = document.querySelector(
                '.application-header',
            );

            if (applicationHeader) {
                const rect = applicationHeader.getBoundingClientRect();
                viewport.headerHeight = rect.height;
            }

            setLastUpdated(Date.now());
        },
    );

    usePollForRef(target, isActive, () => setLastUpdated(Date.now()));

    const targetHeight = (target?.current?.clientHeight ?? 0);

    let center = (viewport.height / 2) -
        frame.offsetTop +
        viewport.scrollTop -
        (targetHeight / 2);

    return {
        center: clamp(
            center,
            24,
            document.body.scrollHeight - targetHeight - 24,
        ),
    };
}
